import {useLogger} from "./useLogger";
import {useQuery} from "@apollo/client";

const {gql} = require("@apollo/client");

const LOCALIZED_QUERY = `
    items {
      sys {
        id
      }
      slug_en_gb: slug(locale: "en-GB")
      slug_de_de: slug(locale: "de-DE")
      slug_de_ch: slug(locale: "de-CH")
      slug_de_at: slug(locale: "de-AT")
      slug_it_it: slug(locale: "it-IT")
      slug_fr_fr: slug(locale: "fr-FR")
      slug_nl_nl: slug(locale: "nl-NL")
    }
`;

const QUERY = gql`query getContent {
  countryCollection {
    ${LOCALIZED_QUERY}
  }
  destinationCollection {
    ${LOCALIZED_QUERY}
  }
  resortCollection {
    ${LOCALIZED_QUERY}
  }
  pageCollection {
    ${LOCALIZED_QUERY}
  }
}`;

export const useLocalizedContent = () => {
    const {logger} = useLogger();
    const {loading, error, data} = useQuery(QUERY);

    if (error?.message) {
        logger(error?.message, "error", "useLocalizedContent", error?.stack);
    }

    return {
        data,
        loading,
        error
    };
};
